import { render, staticRenderFns } from "./orders.page.vue?vue&type=template&id=404a61eb&scoped=true&"
import script from "./orders.page.vue?vue&type=script&lang=js&"
export * from "./orders.page.vue?vue&type=script&lang=js&"
import style0 from "./orders.page.vue?vue&type=style&index=0&id=404a61eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a61eb",
  null
  
)

export default component.exports